import React, { Component } from 'react'
import Lightbox from 'react-images'
import Gallery from 'react-photo-gallery'
import { AppContext } from '@lightspeed-invoicing/core-client/frontend/index'

class ImageGallery extends Component {
    constructor(props, context) {
        super(props, context)
        this.state = {
            className: this.props.className || '',
            disabled: this.props.disabled === true,
            size: this.props.size || 'large',
            images: this.props.value || [],
            lightboxIsOpen: false,
            currentImage: 0,
            imageIds: this.props.imageIds || [],
            initialLoading: true,
            isPdf: this.props.isPdf || false,
            imagesPerRow: this.props.imagesPerRow || '',
        }
        this.closeLightbox = this.closeLightbox.bind(this);
        this.openLightbox = this.openLightbox.bind(this);
        this.gotoNext = this.gotoNext.bind(this);
        this.gotoPrevious = this.gotoPrevious.bind(this);
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.value) {
            this.setState({
                images: nextProps.value,
                className: nextProps.className || '',
                size: nextProps.size || 'large',
                disabled: nextProps.disabled === true,
                imagesPerRow: nextProps.imagesPerRow || '',
            })
            return
        }

        if (nextProps.imageIds && nextProps.imageIds.length > 0 &&
            (this.state.initialLoading || nextProps.imageIds.length !== this.state.imageIds.length)) {
            this.setState({
                initialLoading: false,
            })

            let imageIds = nextProps.imageIds
            if (imageIds.length < this.state.imageIds.length) {
                this.setState({
                    images: this.state.images.filter((image) => imageIds.includes(image.id)),
                    imageIds,
                    className: nextProps.className || '',
                    size: nextProps.size || 'large',
                    disabled: nextProps.disabled === true,
                    imagesPerRow: nextProps.imagesPerRow || '',
                })
            } else {
                imageIds = imageIds.filter((imageId) => this.state.initialLoading || !this.state.imageIds.includes(imageId))
                Promise.all(imageIds.map(imageId => AppContext.getApiClient().get('/images/' + imageId)))
                    .then((images) => {
                        if (!this.state.initialLoading) {
                            images = this.state.images.concat(images)

                        }
                        this.setState({
                            images,
                            imageIds: nextProps.imageIds || [],
                            className: nextProps.className || '',
                            size: nextProps.size || 'large',
                            disabled: nextProps.disabled === true,
                            imagesPerRow: nextProps.imagesPerRow || '',
                        })
                    })
            }
        } else {
            this.setState({
                imageIds: nextProps.imageIds || [],
                className: nextProps.className || '',
                size: nextProps.size || 'large',
                disabled: nextProps.disabled === true,
                imagesPerRow: nextProps.imagesPerRow || '',
            }, () => {
                if (this.state.imageIds.length === 0) {
                    this.setState({
                        images: [],
                    })
                }
            })
        }
    }

    openLightbox(event, obj) {
        if (this.state.disabled) {
            return
        }
        this.setState({
            currentImage: obj.index,
            lightboxIsOpen: true,
        });
    }
    closeLightbox() {
        this.setState({
            currentImage: 0,
            lightboxIsOpen: false,
        });
    }
    gotoPrevious() {
        this.setState({
            currentImage: this.state.currentImage - 1,
        });
    }
    gotoNext() {
        this.setState({
            currentImage: this.state.currentImage + 1,
        });
    }

    render() {
        if (this.state.images.length === 0) {
            return <div />
        }
        const images = this.state.images.map(image => {
            return {
                src: image.attributes.publicUrlBySize["1280x800"] || image.attributes.publicUrl,
                width: image.attributes.originalWidth,
                height: image.attributes.originalHeight,
                srcSet: [
                    (image.attributes.publicUrlBySize["150x150"] || image.attributes.publicUrl) + ' 150w',
                    (image.attributes.publicUrlBySize["640x480"] || image.attributes.publicUrl) + ' 640w',
                    (image.attributes.publicUrlBySize["1280x800"] || image.attributes.publicUrl) + ' 1280w',
                ],
                // sizes: ['(min-width: 480px) 33.3vw,(min-width: 1024px) 20vw,20vw'],
            }
        })

        const imagesPerRow = !isNaN(parseInt(this.state.imagesPerRow)) 
                            ? parseInt(this.state.imagesPerRow)
                            : undefined;

        return (
            <div>
                {this.state.size === 'large' ? <Gallery photos={images} onClick={this.openLightbox} columns={imagesPerRow} /> : <div>
                    {this.state.images.map((image, index) => {
                        let src = image.attributes.publicUrlBySize["150x150"] || image.attributes.publicUrl
                        return <a href={'#'} key={index} onClick={e => {
                            e.preventDefault()
                            this.openLightbox(e, { index: index })
                        }} >
                            <img className={"mr-1 mt-1"} src={src} style={{ height: '80px' }} />
                        </a>
                    })}
                </div>}
                {!this.state.isPdf &&
                    <Lightbox
                        images={images}
                        isOpen={this.state.lightboxIsOpen}
                        currentImage={this.state.currentImage}
                        onClickPrev={this.gotoPrevious}
                        onClickNext={this.gotoNext}
                        onClose={this.closeLightbox}
                    />
                }
            </div>
        )
    }
}

export default ImageGallery





// WEBPACK FOOTER //
// ./src/common/image/gallery.component.jsx